var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.145,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.273 1.343C.273.688.822.158 1.499.158c.679 0 1.228.53 1.228 1.185 0 .652-.55 1.183-1.228 1.183-.677 0-1.226-.53-1.226-1.183zM.273 4.5c0-.655.549-1.184 1.226-1.184.679 0 1.228.529 1.228 1.184 0 .655-.55 1.184-1.228 1.184C.822 5.684.273 5.155.273 4.5zM3.545 4.5c0-.655.55-1.184 1.228-1.184C5.451 3.316 6 3.845 6 4.5c0 .655-.549 1.184-1.227 1.184S3.545 5.155 3.545 4.5zM.273 7.657c0-.652.549-1.183 1.226-1.183.679 0 1.228.53 1.228 1.183 0 .655-.55 1.185-1.228 1.185-.677 0-1.226-.53-1.226-1.185z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.22fc90b5d2d63f4355a1c6297e3be7b5.svg";
export { ForwardRef as ReactComponent };